export default __webpack_public_path__ + "static/media/binance-wallet.358a42f2.png";